import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaStamp } from "react-icons/fa";

import { axiosInstance } from "JS/axios";
import Button from "Components/UI/Button";
import Input from "Components/UI/Input";
import SearchCard from "Components/UI/SearchCard";
import PageContainer from "Components/UI/PageContainer";


const GenerateStamp = () => {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const [imageBlobUrl, setImageBlobUrl] = useState("");
  const [error, setError] = useState(null);

  const handleChangeName = (e) => {
    setName(e.target.value);
    if (error) setError("");
  };

  const handleClick = async () => {
    if (!name.trim()) {
      setError("이름을 입력해주세요.");
      return;
    }

    setLoading(true);
    setImageBlobUrl("");

    try {
      const response = await axiosInstance.get(
        `/v1/admin-page/rect-stamp-name?name=${name}`,
        { responseType: "blob" }
      );

      if (response.data instanceof Blob) {
        const blobUrl = URL.createObjectURL(response.data);
        setImageBlobUrl(blobUrl);
      } else {
        throw new Error("응답 데이터가 Blob 형식이 아닙니다.");
      }
    } catch (error) {
      console.dir(error);
      if (error.message === "로그인 만료") {
        navigate("/");
      }
      setError(error?.response?.data?.detail || "도장 생성에 실패했습니다.");
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = imageBlobUrl;
    link.download = `도장_${name}.jpg`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleClick();
  };

  useEffect(() => {
    document.title = "마크픽 관리자 > 이름 도장 생성";
  }, []);

  return (
    <PageContainer title="이름 도장 생성" icon={<FaStamp />}>
      <SearchCard style={{ width: "400px" }}>
        <div style={{ padding: "16px", width : '500px'}}>
          <form
            onSubmit={handleSubmit}
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "var(--spacing-md)",
            }}
          >
            <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
              <label style={{ fontWeight: "500", fontSize: "14px" }}>도장 생성</label>
              <Input
                value={name}
                onChange={handleChangeName}
                placeholder="이름을 입력하세요"
                style={{ minWidth: "250px" }}
              />
            </div>
            
            <div>
              <Button onClick={handleClick} style={{ height: "fit-content" }}>
                {loading ? "생성 중..." : "도장 생성"}
              </Button>
            </div>
            
            {error && (
              <div>
                <p style={{ color: "#dc2626", margin: 0 }}>
                  {typeof error === "string" ? error : "오류가 발생했습니다."}
                </p>
              </div>
            )}
          </form>
        </div>
      </SearchCard>
      {imageBlobUrl && (
        <div
          style={{
            padding: "var(--spacing-md)",
            width: "400px",
            backgroundColor: "var(--color-surface)",
            borderRadius: "var(--border-radius-xl)",
            boxShadow: "var(--shadow-md)",
          }}
        >
          <div>
            <p
              style={{ fontWeight: "bold", marginBottom: "var(--spacing-md)" }}
            >
              도장 미리보기
            </p>
            <div
              style={{
                display: "flex",
                alignItems: "end",
                gap: "var(--spacing-xs)",
              }}
            >
              <img
                src={imageBlobUrl}
                alt="도장 미리보기"
                style={{
                  width: 200,
                  height: "auto",
                  border: "1px solid #e5e7eb",
                  borderRadius: 12,
                }}
              />
            </div>
            <Button
              onClick={handleDownload}
              style={{ marginTop: 12, width: "200px" }}
            >
              다운로드
            </Button>
          </div>
        </div>
      )}
    </PageContainer>
  );
};

export default GenerateStamp;